<div class="sale-terms-condition-popup">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Terms and Conditons</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <h5>Viewing Repository Data Instructions</h5>
    <p>{{ data.viewingHelp }}</p>
    <h5>Submitting Repository Data Instructions</h5>
    <p>{{ data.studyHelp }}</p>
    <ul>
      <li>
        <a class="link" (click)="openPDF(data.termsAndConditions)"
          >Click here</a
        >
        to review the Terms and Conditons
      </li>
      <li>
        <a class="link" (click)="openPDF(data.privacyPolicy)">Click here</a> to
        review the Privacy Policy
      </li>
    </ul>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closePopup()">
      Accept & Continue
    </button>
  </div>
</div>
